const RestServiceOpts = {
  logXhr: false
};

const WorkspaceConfig = {
  ...RestServiceOpts
};

export default WorkspaceConfig;
